
import ContactForm from '../components/ContactForm';
import Logo from '../components/Logo';
import VideoBackground from '../components/VideoBackground';
import QASection from '../components/QASection';

function Contact() {
  

  return (
    <>
      <VideoBackground/>
      <Logo/>
      
      
      <ContactForm/>
      <QASection/>
      
    </>  
  );
}

export default Contact;